<template>
  <div class="tw:max-h-80 tw:overflow-y-auto">
    <div v-for="(member, index) in memberItems" :key="member.id">
      <div v-if="index > 0" class="tw:border-t tw:border-gray-200"></div>
      <label class="tw:flex tw:items-center tw:justify-between tw:gap-3 tw:py-2.5 tw:cursor-pointer tw:m-0">
        <div class="tw:flex tw:items-center tw:gap-3 tw:min-w-0">
          <Avatar :username="`${member.user.firstname} ${member.user.lastname}`" :size="30" />
          <div class="tw:flex tw:flex-col tw:min-w-0">
            <div class="tw:flex tw:items-center tw:gap-2">
              <strong class="tw:truncate">{{ member.user.firstname }} {{ member.user.lastname }}</strong>
              <Badge v-if="member.is_owner" variant="yellow" class="tw:shrink-0">
                {{ $t("Admin") }}
              </Badge>
            </div>
            <small class="text-muted tw:truncate">{{ member.user.email }}</small>
          </div>
        </div>
        <Switch :model-value="isSelected(member.id)" @update:model-value="() => toggle(member.id)" class="tw:shrink-0 tw:mr-2" />
      </label>
    </div>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import Avatar from "@/components/ui/Avatar.vue";
import Badge from "@/components/ui/badge/Badge.vue";
import { Switch } from "@/shadcn/components/ui/switch";
import useItemSelection from "@/composables/useItemSelection";

const props = defineProps({
  permissions: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['update:selectedIds']);

const memberItems = computed(() =>
  props.permissions.map(p => ({
    id: p.user.id,
    user: p.user,
    is_owner: p.is_owner,
  }))
);

const {
  selectedIds,
  isSelected,
  toggle,
} = useItemSelection({ items: memberItems });

watch(memberItems, (items) => {
  const ids = items.map(item => item.id);
  selectedIds.value = ids;
  emit('update:selectedIds', [...ids]);
}, { immediate: true });

watch(selectedIds, (ids) => {
  emit('update:selectedIds', [...ids]);
}, { deep: true });

defineExpose({ selectedIds });
</script>
